import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cr0038',
    ecrans: ['00-2'],
    params: ['?clicleint']
});
